export default (function (_ref) {
  var request = _ref.request;
  return {
    breedWaterManageAdd: function breedWaterManageAdd(data) {
      return request({
        url: '/cms/breedWaterManage/add',
        method: 'post',
        data: data
      });
    },
    breedWaterManageModify: function breedWaterManageModify(data) {
      return request({
        url: "/cms/breedWaterManage/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    breedWaterManageDel: function breedWaterManageDel(id) {
      return request({
        url: "/cms/breedWaterManage/".concat(id, "/del"),
        method: 'delete'
      });
    },
    breedWaterManageQuery: function breedWaterManageQuery(data) {
      return request({
        url: '/cms/breedWaterManage',
        method: 'get',
        params: data
      });
    },
    breedWaterManageDetail: function breedWaterManageDetail(id) {
      return request({
        url: "/cms/breedWaterManage/".concat(id),
        method: 'get'
      });
    }
  };
});